import { useQuery } from '@tanstack/react-query';

import { errorDeserialize } from 'helpers/error-deserializer';
import { CountryResponse } from 'services/connectivity/country/types';
import { countryClient } from 'services/connectivity/country/client';

type UseGetCountry = {
  country: string | undefined;
  isLoading: boolean;
  isError: boolean;
};

export const fetchCountry = async (): Promise<CountryResponse> => {
  const { error, result } = await countryClient.get();

  if (error) {
    throw errorDeserialize(error);
  }

  return result;
};

export const useGetCountry = (): UseGetCountry => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['get-country'],
    queryFn: () => fetchCountry(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
  });

  return {
    country: data?.result,
    isLoading,
    isError,
  };
};
